import Vue from "vue"
import VueI18n from "vue-i18n"
import store from '@/store'

Vue.use(VueI18n)

import ZH from "./zh"
import EN from "./en"


const i18n =new VueI18n({
    locale:store.getters.language||"zh",
    messages:{
        zh:{...ZH},
        en:{...EN},
    }
})

export default i18n